// extracted by mini-css-extract-plugin
export default {"indicator":"styles_indicator__+Yuok","growing":"styles_growing__OF5Xp"};